"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const components_1 = require("components");
const config_1 = require("config");
const actions_1 = require("../actions");
const components_2 = require("../components");
const OfferCard_1 = __importDefault(require("../components/OfferCard"));
const reducer_1 = require("../reducer");
/*
  This page is shown when the user is hard declined by Bread.
  If the user has an Imprint offer, it is shown here and the
  user can select it and return to the Wizard.
*/
function DeclinedPage() {
    const history = (0, react_router_dom_1.useHistory)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const prequalification = (0, react_redux_1.useSelector)(reducer_1.selectors.prequalification);
    if (!prequalification) {
        history.push(config_1.APPLICATION_FINDER_URL);
        return null;
    }
    const offers = prequalification.offers ?? [];
    const imprintOffer = offers.find((offer) => offer.serviceProviderName === 'Imprint' &&
        offer.offerType === 'prequalified');
    const handleSelectOffer = () => {
        const updatedOffers = offers.filter((offer) => {
            return offer.serviceProviderName !== 'ADS';
        });
        dispatch((0, actions_1.setPrequalification)({ ...prequalification, offers: updatedOffers }));
        history.push({
            pathname: config_1.WIZARD_URL,
            state: {
                step: 'PRE-QUALIFICATION',
                fromfindMyApp: true,
            },
        });
    };
    return ((0, jsx_runtime_1.jsx)("div", { className: "declined-container", children: imprintOffer ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(components_1.H1, { variant: "title-extra-large", children: "We were unable to provide you with an Alphaeon Card. Please see below your Alphaeon Advantage offer." }), (0, jsx_runtime_1.jsx)(DeclinedResponse, { withBoxShadow: true }), (0, jsx_runtime_1.jsx)("div", { className: "w100", children: (0, jsx_runtime_1.jsx)(OfferCard_1.default, { offer: imprintOffer, selectOfferCallback: handleSelectOffer }) })] })) : ((0, jsx_runtime_1.jsx)(DeclinedResponse, {})) }));
}
const DeclinedResponse = ({ withBoxShadow = false, }) => {
    return ((0, jsx_runtime_1.jsxs)("div", { className: (0, classnames_1.default)({
            'w100 pad-20 border-none': true,
            'box-shadow-glow': withBoxShadow,
        }), children: [(0, jsx_runtime_1.jsx)(components_1.P, { children: "Thank you for your interest in the Alphaeon Credit Card." }), (0, jsx_runtime_1.jsx)(components_1.P, { className: "mar-t-20", children: "We\u2019re reviewing the information you provided and will contact you by mail within 10 business days regarding the status of your application." }), (0, jsx_runtime_1.jsx)(components_2.ContactInfo, {})] }));
};
exports.default = DeclinedPage;
